import { render } from "./CollectionList.vue?vue&type=template&id=942daa82&scoped=true&ts=true"
import script from "./CollectionList.vue?vue&type=script&lang=ts"
export * from "./CollectionList.vue?vue&type=script&lang=ts"

import "./CollectionList.vue?vue&type=style&index=0&id=942daa82&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942daa82"]])

export default __exports__